module.exports = __webpack_public_path__ + "static/media/About_Membership.28d189df.md";